import { AlertTriangle, ArrowRight, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

const CrisisResourceCard = () => {
  const { t } = useTranslation('practitioners');

  return (
    <Card className="border-2 border-red-500 bg-red-50 shadow-lg mb-6 animate-in fade-in-0 duration-300">
      <CardContent className="p-6">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0">
            <div className="w-12 h-12 rounded-full bg-red-500 flex items-center justify-center">
              <AlertTriangle className="h-6 w-6 text-white" />
            </div>
          </div>
          <div className="flex-1">
            <h3 className="text-xl font-bold text-red-900 mb-2 flex items-center gap-2">
              <Phone className="h-5 w-5" />
              {t('crisisResourcesTitle')}
            </h3>
            <p className="text-red-800 mb-4">
              {t('crisisResourcesDescription')}
            </p>
            <Button asChild variant="default" className="bg-red-600 hover:bg-red-700 text-white">
              <Link to="/crisis-resources">
                {t('viewCrisisResources')}
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default CrisisResourceCard;
